const Config = {
    imgPrefix: "https://jp-reservation-app.oss-cn-hangzhou.aliyuncs.com/",
    publicKey: `-----BEGIN RSA PUBLIC KEY-----
MIIBCgKCAQEA7OeV239eBM43tTNOly9hrFwVKXA3UKACs3n1jN5K9KCpvUSmogIu
ytQIyDbe2a3nxW6Sfuk5RNuSHbEaJ80B+TZQfRGbwhY4hpD5cXVeqZHab4fo9GRn
PNnyVluSYDWVEQTYko2aewPHticWgoacpbhez65q0vKzZDjcGq3NYC/3kcjn7zXW
DNxQAd7adED8BKUJi0G9zLRb7ZMbzmwbu3blyeKK+NZir5s2rz5WDRF2HPwlAq0t
tfNP3ziMA/aKdZgjLxVf+q/dVJXYVB79+HTf3rB6Lp5IDUqQNcsFVtR2IqrU7Pym
AgRwsmrSdqOof9BwzrVKfu7jRCfYtVAi6QIDAQAB
-----END RSA PUBLIC KEY-----`,
    // imgPrefix: "https://seastart-project.oss-cn-hangzhou.aliyuncs.com/",

}
export default Config